import { NextSeo } from 'next-seo';
import * as React from 'react';

import { Video } from '@/lib/videos';

import FAQSection from '@/components/landing/FAQSection';
import FeaturesSection, { Feature } from '@/components/landing/FeaturesSection';
import GetStartedSection from '@/components/landing/GetStartedSection';
import HeroSection from '@/components/landing/HeroSection';
import TestimonialsSection from '@/components/landing/TestimonialsSection';
import Layout from '@/components/layout/Layout';

const title = `Turn podcasts into viral clips (in seconds)`;
const ForStudiosPage: React.FC<{ videos: Video[] }> = ({ videos }) => {
  return (
    <>
      <NextSeo title={title} />
      <Layout mode='light'>
        <main>
          <HeroSection
            pageType='For Podcast Studios'
            titleTop='Offer short-form clips to your studio clients'
            titleBottom=''
            subtitle='We use AI to automatically find the best moments of your podcast and give you ready-to-post clips within minutes.'
          />
          {/*<DemoVideoSection />*/}
          <FeaturesSection>
            <Feature
              name='Offer a clip package'
              description='Offer a clip package as an additional pricing option to your clients.'
              image='/images/sell-clip-package.png'
              alt='Hero image'
            />
            <Feature
              name='Minimize outsourcing'
              description='Hiring a third party to make clips for your clients can be expensive and time consuming.'
              image='/images/minimize-outsourcing-1.png'
              alt='Hero image'
              flipped
            />
            <Feature
              name='Faster turnaround'
              description='Deliver high-quality clips faster and meet demanding deadlines with ease.'
              image='/images/faster-turnaround.png'
              alt='Hero image'
            />
            <Feature
              name='Cut production costs'
              description='Pay less than 10x the price of what it costs to hire an editor.'
              image='/images/lower-price-3.png'
              alt='Hero image'
              flipped
            />
          </FeaturesSection>
          <TestimonialsSection />
          <FAQSection />
          <GetStartedSection />
        </main>
      </Layout>
    </>
  );
};

export default ForStudiosPage;
